const styles = {
  serialNumberCol: { width: "8%" },
  nameAndAddressCol: { width: "45%" },
  nominationDetails:  { lineHeight: 2 },
  employerCertify:  { lineHeight: 2.5 },
  ageOfNomineeCol: { width: "10%" },
  relationShipCol: { width: "17%" },
  detailsKeyColumn: { width: "32%" },
  formFDetails: {
    display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "space-around", height: 260, marginLeft: 5
  },
  dependantPoint: { marginLeft: 11, marginTop: 5 },
  witnessSignature: { textAlign: "right", margin: "10 80 10 0" },
  signedNomination: { margin: "15 10 0" },
  thanaOrDistrict: { width: "8%" },
  thanaOrDistrictValue: { width: "24%" },
  subDivisionOrState: { width: "14%" },
  villageOrPostOffice: { width: "14%" },
  hrLineNearEmployerCertify: { margin: "10 30" },
  hrLineNearWitnessDeclaration: { margin: "20 30 10" },
  certifyByEmployer: { fontWeight: "medium", margin: "auto" },
  employerSignature: { alignItems: "center", lineHeight: 2 },
  nameAndEstablishmentAddress: { margin: "20 20 0 50" }
};

export default styles;
